/**
 * Favorites Store
 */

define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var server = require('server');
    var user = require('user');
    var AbstractStore = require('stores/abstract.store');
    var FavoritesCollection = require('stores/favorites/favorites.collection');
    var core = require('core');

    var FavoritesStore = AbstractStore.extend({
        type: 'Favorites',
        /**
         * Collection with favorites models
         * @type {FavoritesCollection}
         */
        _collection: new FavoritesCollection(),

        subscribe: function() {
            this.listenTo(core, 'auth:login auth:logout', this.refetch);
        },

        fetch: function(isForceUpdate) {
            return this._handleFetch(function() {
                var result = $.Deferred();

                if (user.isLoggedIn()) {
                    this._collection.fetch({
                        success: result.resolve,
                        error: result.reject
                    });
                } else {
                    this._collection.reset();
                    result.resolve();
                }

                return result.promise();

            }.bind(this), isForceUpdate);
        },

        getItem: function(favoriteID) {
            return this._collection.findWhere({
                favoriteID: favoriteID
            });
        },

        /**
         * Change priority of favorite item
         * @param  {Model}  favorite    favorite Model
         * @param  {Number} priority    new priority of favorite
         * @return {Deferred}
         */
        changePriority: function(favorite, priority) {
            this._collection.remove(favorite, {silent: true});
            this._collection.add(favorite, {
                at: priority - 1,
                silent: true
            });
            this._collection.each(function(favoriteModel, index) {
                favoriteModel.set('priority', index + 1);
            });

            return server.send({
                ID: 89107,
                responses: [89106, 89108],
                favoriteID: favorite.id,
                priority: priority
            });
        }
    });

    module.exports = FavoritesStore;
});
